import React, {useState} from 'react'
import {Row, Col, Tab, Tabs} from 'react-bootstrap'
import materialtextures from './config/material.json'
import {CaretRight} from 'react-bootstrap-icons'
import ReactTooltip from 'react-tooltip'
import TextureSelectionPad from './TextureSelectorPad' 
import DoorPositioning from './DoorPositioning'
import './css/ConfiguratorPads.css'

const floorDescr = ['Fisrt','Second','Third','Fourth','Fifth','Sixth'];
const basedir = `${process.env.PUBLIC_URL}`;

export default function FloorConfigurationPad (props) 
{
    const [openDoorMaterial, setOpenDoorMaterial] = useState([false,false,false]);
    const [openWallMaterial, setOpenWallMaterial] = useState([false,false,false]);
    const [currentfloor,setFloor] = useState(0);
    

    const handleUpdateDoors = (config,floor)=>{
        let newconfig = props.floors;
        newconfig[floor].doors = JSON.parse(config);
        props.update( JSON.stringify(newconfig) );
    }

    const handleOpenDoorMaterial = (obj)=>{
        if(!obj) return;
        let b = !openDoorMaterial[obj.dataset.keyside];
        let barray = [false,false,false];
        barray[obj.dataset.keyside] = b;
        setOpenDoorMaterial(barray);
        setOpenWallMaterial([false,false,false]);
    }

    const handleOpenWallMaterial = (obj)=>{
        if(!obj) return;
        let b = !openWallMaterial[obj.dataset.keyside];
        let barray = [false,false,false];
        barray[obj.dataset.keyside] = b;
        setOpenWallMaterial(barray);
        setOpenDoorMaterial([false,false,false]);
    }


    const handleSideMaterial = (config,part,floor,side)=>{
        let newconfig = props.floors;
        newconfig[floor][part][side] = JSON.parse(config);
        props.update( JSON.stringify(newconfig) );

    }

    const setCurrentFloorHeightInput = e=>{
        let newconfig = props.floors;
        newconfig[e.target.dataset.keyfloor].height = parseInt(e.target.value);
        props.update( JSON.stringify(newconfig) );
    }

    const setCurrentInterFloorSizeInput = e=>{
        let newconfig = props.floors;
        newconfig[e.target.dataset.keyfloor].ceil.height = parseInt(e.target.value);
        props.update( JSON.stringify(newconfig) );
    }

    
    const SideThumb = (params)=>{
        const part = props.floors[params.floor][params.part][params.side];
        if( ! part ) return;

        const m = part.material;
        const t = part.texture;
        const p = part.type;
       
        const panelstyle = p==='color'? {backgroundColor: materialtextures[m][t]}:
                                        {backgroundImage: `url(${basedir}/textures/${materialtextures[m][t]}`};
                    
        return(
            <>
                <div 
                    style={panelstyle}
                    className='thumbnail sm-thumbnail'
                    onClick={e=>{
                        params.part==='doors'?
                            handleOpenDoorMaterial(e.target):
                            handleOpenWallMaterial(e.target)
                        }}
                    data-keyfloor={params.floor} 
                    data-keyside={params.keyside} 
                    data-tip
                    data-for={`texttip-${params.part}-${params.floor}-${params.side}`}
                />
                <ReactTooltip id={`texttip-${params.part}-${params.floor}-${params.side}`} place='right' effect='solid'>
                    {`${t} [${m}]`}
                </ReactTooltip>
            </>    
        )
    };

    const floortabs = props.floors.map( (fl, keyfloor)=>{

        const doorConfig = Object.keys(fl.doors).map((side,keyside)=>{
            return(
                <Row key={`floordoor-${fl}-${side}`}>
                    <Col className='col-5 p-2 mt-2'>
                        <h6 className="conf-title" onClick={e=>handleOpenDoorMaterial(e.target)} data-keyfloor={keyfloor} data-keyside={keyside}>DOOR SIDE {side.toUpperCase()}</h6>
                    </Col>
                    <Col className='col-4 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openDoorMaterial[keyside]?' deg90':null} data-keyfloor={keyfloor} data-keyside={keyside}  onClick={e=>handleOpenDoorMaterial(e.target)}/>
                        </h5>
                    </Col>
                    <Col className='col-2 p-2'>
                        <SideThumb part='doors' floor={keyfloor} keyside={keyside} side={side}/>
                    </Col>
                    {openDoorMaterial[keyside]?
                    <TextureSelectionPad 
                        sections={['door glass']}
                        select={config=>handleSideMaterial(config,'doors',keyfloor,side)}
                        variation='sm'
                    />
                    :null}
                </Row>
            )            
        })

        const wallConfig = Object.keys(fl.walls).map((side,keyside)=>{
            return(
                <Row key={`floorwall-${fl}-${side}`}>
                    <Col className='col-5 p-2 mt-2'>
                        <h6 className="conf-title" onClick={e=>handleOpenWallMaterial(e.target)} data-keyfloor={keyfloor} data-keyside={keyside}>WALL SIDE {side.toUpperCase()}</h6>
                    </Col>
                    <Col className='col-4 p-2'>
                        <h5 className='leggera-open-btn'>
                            <CaretRight className={openWallMaterial[keyside]?' deg90':null} data-keyfloor={keyfloor} data-keyside={keyside}  onClick={e=>handleOpenWallMaterial(e.target)}/>
                        </h5>
                    </Col>
                    <Col className='col-2 p-2'>
                        <SideThumb part='walls' floor={keyfloor} keyside={keyside} side={side}/>
                    </Col>
                    {openWallMaterial[keyside]?
                    <TextureSelectionPad 
                        sections={['glass','alluminium','steel','matte']}
                        select={config=>handleSideMaterial(config,'walls',keyfloor,side)}
                        variation='sm'
                    />
                    :null}
                </Row>
            )            
        })

        const otherConfig =                     
            <>
                <Row key={`flparams-flheigth-${fl}`}>                    
                    <Col className='col-7 p-2 mt-2'>
                        <h6 className="conf-title">FLOOR HEIGHT</h6>
                    </Col>
                    <Col className='col-4 p-2 mt-2'>
                        <h6 >
                            <input 
                                data-keyfloor={keyfloor}
                                type="number" 
                                min={200}
                                max={600}
                                value={props.floors[keyfloor].height} 
                                style={{width: "4rem"}}
                                onChange={setCurrentFloorHeightInput}
                            />&nbsp;&nbsp;cm
                        </h6>
                    </Col>
                </Row>
                <Row key={`flparams-intflwidth-${fl}`}>                    
                    <Col className='col-7 p-2 mt-2'>
                        <h6 className="conf-title">INTERFLOOR WIDTH</h6>
                    </Col>
                    <Col className='col-4 p-2 mt-2'>
                        <h6 >
                            <input 
                                data-keyfloor={keyfloor}
                                type="number" 
                                min={0}
                                max={100}
                                value={props.floors[keyfloor].ceil.height} 
                                style={{width: "4rem"}}
                                onChange={setCurrentInterFloorSizeInput}
                            />&nbsp;&nbsp;cm
                        </h6>
                    </Col>
                    </Row>                
            </>;


        return(
            <Tab 
                key={`floortab-${keyfloor}`} 
                eventKey={keyfloor} 
                data-floor={keyfloor} 
                title={floorDescr[keyfloor].toUpperCase()} 
            >
                <Row>
                    <Col className='col-5'>
                        <DoorPositioning doors={fl.doors} floor={keyfloor} update={handleUpdateDoors}/>
                    </Col>
                    <Col className='col-7'>
                        {otherConfig}
                        <hr/>
                        {doorConfig}
                        <hr/>
                        {wallConfig}
                    </Col>
                </Row>
            </Tab>        
        )
    })

    return (
        <Tabs 
            className='leggera-tab'        
            activeKey={currentfloor}
            onSelect={f=>{setFloor(f)}}
        >
            {floortabs}
        </Tabs>
    );
}

